import React from 'react';
import Header from 'cccisd-header';
import style from './style.css';

const Fortress = window.cccisd.fortress;
const questTabPermissions = [
    'quest.admin',
    'quest.design',
    'quest.deploy',
    'quest.status',
    'quest.code',
    'quest.tables',
    'quest.permissions',
];

export default props => {
    const { hideSecondaryNav } = props;
    const primaryNavLinks = [];

    if (
        Fortress &&
        Fortress.auth() &&
        !Fortress.user.acting.is_super_user &&
        Fortress.hasAnyAccess(questTabPermissions, 'anyTarget')
    ) {
        primaryNavLinks.push({ url: '/quest', label: 'Quest' });
    }

    return (
        <div>
            <Header
                containerClassName="container-fluid"
                wrapperClassName={style.wrapper}
                logoClassName={style.logo}
                primaryNavLinks={primaryNavLinks}
                secondaryNavLinks={hideSecondaryNav ? '' : 'header'}
                showHomeAction={false}
                showAdminAction={Fortress.hasRole('uberadmin')}
            />
        </div>
    );
};
